import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.799 6.044a1.6 1.6 0 0 1 .653 1.28c0 4.037.141 5.123.72 5.536.38.27.901.267 2.656.22.815-.023 1.86-.053 3.228-.053.545 0 1.06.225 1.408.616.323.364.465.839.39 1.306-.64 3.981-4.162 6.872-8.376 6.872C5.803 21.821 2 18.164 2 13.67c0-3.564 2.803-7.128 6.248-7.943a1.89 1.89 0 0 1 1.55.317M8.684 7.057a.4.4 0 0 0-.092.01c-2.843.673-5.156 3.635-5.156 6.603 0 3.733 3.159 6.77 7.042 6.77 3.501 0 6.426-2.397 6.957-5.702.004-.027.017-.107-.061-.197a.43.43 0 0 0-.318-.133c-1.351 0-2.382.03-3.187.052-1.949.056-2.755.077-3.551-.491-1.14-.811-1.289-2.175-1.301-6.002l-.001-.643a.23.23 0 0 0-.104-.193.38.38 0 0 0-.228-.074M19.279 4.69c1.683 1.618 2.751 3.743 2.72 5.415-.011.653-.504 1.198-1.17 1.294-1.3.189-2.822.246-4.17.246-1.253 0-2.357-.049-2.992-.084-.798-.045-1.434-.657-1.48-1.424-.074-1.217-.236-4.31-.121-6.7.031-.695.615-1.248 1.33-1.26 2.045-.057 4.156.856 5.883 2.513m-5.76-1.134h-.022c-.105 2.319.05 5.314.123 6.5.004.071.058.123.13.127.985.054 4.375.205 6.814-.14.005-1.293-.915-3.045-2.3-4.376-1.42-1.364-3.101-2.11-4.746-2.11",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }